import type { ComponentSingleStyleConfig } from '@chakra-ui/react';

export const MonolithLinkConfig: ComponentSingleStyleConfig = {
  baseStyle: {
    _hover: {
      color: 'initial',
    },
  },
};
